import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  // Logic to check if current user is admin
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;
  const isAdmin = user && user.role === 'admin';

  return (
    <footer style={{
      backgroundColor: '#212529',
      color: 'white',
      padding: '3rem 0 1.5rem 0',
      marginTop: '4rem',
      borderTop: '5px solid #007bff'
    }}>
      <div className="container" style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '30px'
      }}>
        
        {/* ABOUT SECTION */}
        <div style={{ flex: '1.5', minWidth: '300px' }}>
          <h3 style={{ color: '#007bff', marginBottom: '15px' }}>OnRoad Assist 🛠️</h3>
          <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#adb5bd' }}>
            Developed by <strong>Shashank Shashu</strong> & <strong>Arjun D</strong>, 
            6th Sem BCA students at <strong>Spurthy College of Science and Management Studies</strong>. 
            This platform is designed to provide rapid emergency support for vehicle breakdowns, 
            ensuring safety and reliability on the road.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div style={{ flex: '1', minWidth: '150px' }}>
          <h4 style={{ marginBottom: '15px', borderBottom: '2px solid #007bff', display: 'inline-block' }}>Explore</h4>
          <ul style={{ listStyle: 'none', padding: 0, fontSize: '14px', lineHeight: '2.5' }}>
            <li><Link to="/" style={{ color: '#adb5bd', textDecoration: 'none' }}>Home</Link></li>
            <li><Link to="/about" style={{ color: '#adb5bd', textDecoration: 'none' }}>About Us</Link></li>
            <li><Link to="/contact" style={{ color: '#adb5bd', textDecoration: 'none' }}>Contact Us</Link></li>
            <li><Link to="/terms" style={{ color: '#adb5bd', textDecoration: 'none' }}>Terms & Conditions</Link></li>
            
            {/* Show these only if Admin is logged in */}
            {isAdmin && (
              <>
                <li><Link to="/user-dashboard" style={{ color: '#007bff', textDecoration: 'none' }}>User Portal</Link></li>
                <li><Link to="/mechanic-dashboard" style={{ color: '#007bff', textDecoration: 'none' }}>Mechanic Portal</Link></li>
              </>
            )}
          </ul>
        </div>

        {/* CONTACT SECTION */}
        <div style={{ flex: '1', minWidth: '200px' }}>
          <h4 style={{ marginBottom: '15px', borderBottom: '2px solid #007bff', display: 'inline-block' }}>Contact Support</h4>
          <p style={{ fontSize: '14px', color: '#adb5bd', margin: '8px 0' }}>📍 Bangalore, Karnataka</p>
          <p style={{ fontSize: '14px', color: '#adb5bd', margin: '8px 0' }}>📞 +91 90194 99599</p>
          <p style={{ fontSize: '14px', color: '#adb5bd', margin: '8px 0' }}>📧 Shashankshashu515@gmail.com</p>
          <p style={{ fontSize: '14px', color: '#dc3545', fontWeight: 'bold', marginTop: '15px' }}>🚨 Emergency: 112</p>
        </div>

      </div>

      <div style={{
        textAlign: 'center',
        marginTop: '3rem',
        paddingTop: '1.5rem',
        borderTop: '1px solid #343a40',
        fontSize: '13px',
        color: '#6c757d'
      }}>
        &copy; {currentYear} OnRoad Assist | Developed as a Final Year Project | <strong>Spurthy College</strong>
      </div>
    </footer>
  );
};

export default Footer;